<script lang="ts">
  export let handleClearFilters: (() => void) | undefined;
  export let customClass = '';
</script>

<button on:click={handleClearFilters} class={customClass}>Clear All</button>
